
import { UserSubscription } from "functions/src/Users/UsersInterfaces";
import {
  normalizePackageLabel,
  PKG_FLY,
  PKG_GO,
  PKG_WIN,
} from "functions/src/Subscriptions/packageIds";
import { defineComponent } from "vue";
import { mapGetters } from "vuex";
import { tools } from "@/mixins/tools";
import PackageIcon from "@/components/common/PackageIcon.vue";
import dayjs from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat";
import timezone from "dayjs/plugin/timezone";
dayjs.extend(timezone);
dayjs.extend(advancedFormat);

export default defineComponent({
  name: "subscriptions-card",
  components: { PackageIcon },
  computed: {
    ...mapGetters("subs", ["getUserSubscription", "getUserCurrentPackage"]),
    /** El nivel del usuario, traducido una vez para todos los `switch` de abajo. */
    level(): string {
      return normalizePackageLabel(this.getUserCurrentPackage) || PKG_FLY;
    },
    packageSubscription(): UserSubscription {
      // Lo que sale de aquí es un DOC-ID, no un nivel: se pide el id de siempre
      // y `getUserSubscription` resuelve la familia entera.
      switch (this.level) {
        case PKG_GO:
          return this.getUserSubscription("gtr-lite");
        case PKG_FLY:
        case PKG_WIN:
        default:
          return this.getUserSubscription("trading-academy");
      }
    },
    distributorLicenseSubscription(): UserSubscription {
      // EL EMPAREJAMIENTO SE QUEDA: qué licencia le toca a cada nivel no cambia.
      // Los DOC-ID que salen siguen siendo los viejos porque `getUserSubscription`
      // resuelve la FAMILIA de cada licencia —la suya ∪ la GLOBAL— y devuelve la
      // que caduca más tarde. Preguntar por el id viejo es preguntar por la familia.
      switch (this.level) {
        case PKG_GO:
          return this.getUserSubscription("lite-distributor-license");
        case PKG_FLY:
        case PKG_WIN:
        default:
          return this.getUserSubscription("distributor-license");
      }
    },
    packageName(): string {
      switch (this.level) {
        case PKG_GO:
          return "GTR Go";
        case PKG_WIN:
          return "GTR Win";
        case PKG_FLY:
        default:
          return "GTR Fly";
      }
    },
    packageFormattedEndDate(): string {
      return this.packageSubscription.endDate
        ? this.formatDateTimezone(
            (this.packageSubscription.endDate as Date).getTime()
          )
        : "-";
    },
    packageDurationUnitLocalized(): string {
      return tools.methods.durationUnitLocalized(
        this.packageSubscription.daysLeft || 0,
        "days"
      );
    },
    licenseFormattedEndDate(): string {
      return this.distributorLicenseSubscription.endDate
        ? this.formatDateTimezone(
            (this.distributorLicenseSubscription.endDate as Date).getTime()
          )
        : "-";
    },
    licenseDurationUnitLocalized(): string {
      return tools.methods.durationUnitLocalized(
        this.distributorLicenseSubscription.daysLeft || 0,
        "days"
      );
    },
  },
  methods: {
    formatDateTimezone(milliseconds: number): string {
      return milliseconds == 0
        ? "-"
        : tools.methods.formatDateTimezone(milliseconds);
    },
    daysLeftClass(daysLeft: number): string {
      if (daysLeft <= 5) {
        return "bg-danger";
      } else if (daysLeft <= 10) {
        return "bg-warning";
      } else {
        return "bg-success";
      }
    },
  },
});
